import { useCallback } from 'react';
import { updateConfigAlarma } from '../actions/alarmaActions';


function useDeviceConfig({
    command,
    config,
    setState,
    originalConfigRef,
    currentUser,
    device,
    dispatch,
    startLoading,
    endLoading,
    extraValidation // opcional
}) {

    const sendConfig = useCallback(async () => {

        // 🔒 VALIDACIÓN OPCIONAL
        if (extraValidation) {
            const error = extraValidation(config);
            if (error) {
                alert(error);
                return;
            }
        }

        //console.log(`--- Enviando ${command} ---`, config);

        startLoading?.();

        setState(prev => ({
            ...prev,
            configId: "---",
            estado: "Esperando respuesta del servidor/dispositivo",
            color: "black"
        }));

        try {
            const result = await updateConfigAlarma(
                currentUser,
                device.devId,
                command,
                config,
                dispatch
            );

            if (result?.deviceResponse === 0) {

                originalConfigRef.current = JSON.parse(JSON.stringify(config));

                setState(prev => ({
                    ...prev,
                    formDirty: false,
                    configId: result.insertId,
                    estado: "Última configuración actualizada con éxito.",
                    color: "green"
                }));

                alert(`Configuración enviada con éxito (ID: ${result.insertId})`);

            } else {
                throw new Error("Device error");
            }

        } catch (err) {
            //console.error(err);

            setState(prev => ({
                ...prev,
                configId: 0,
                estado: "Error. Última configuración NO actualizada.",
                color: "red"
            }));

            alert("Error al enviar la configuración.");
        }

        endLoading?.();

    }, [
        command,
        config,
        setState,
        originalConfigRef,
        currentUser,
        device,
        dispatch,
        startLoading,
        endLoading,
        extraValidation
    ]);

    return { sendConfig };
}

export default useDeviceConfig;